'use strict';

var availabilityStatus = {};

exports.__exports = availabilityStatus;
//# sourceMappingURL=availabilityStatus.cjs.map
